import { updateLazy } from "Functions/lazy";
import { initAnchors, scrollToEl } from "Functions/anchor";

import "Layouts/default";

import "Ui/shorten";
import "Ui/more-items";
import "Ui/slider";

import "./catalog-jquery";
import "./filter-slider";
import "./categories-filter";
import "./price-filter";
import "./multiselect";
import "./filter-bubbles";

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll(".pager__list .c-btn")) {
        if (pagerButton.classList.contains("is-active")) continue;

        pagerButton.addEventListener("click", (event) => {
            scrollToEl(document.querySelector(".c-listing-main__products"), 200);
        });
    }
};

// Filter with manufacturer box above product list
const manufacturerFilterTriggers = document.querySelector(".js-manufacturer-filter-triggers");

if (manufacturerFilterTriggers) {
    manufacturerFilterTriggers
        .querySelectorAll(".js-trigger-manufacturer-filter")
        .forEach((trigger) => {
            trigger.addEventListener("click", (event) => {
                event.preventDefault();

                const id = trigger.dataset.id;

                // reset everything
                $("#filter").find(".js-reset").click();

                // handle select
                const selectElement = document.getElementById("filter_manufacturers");
                selectElement.querySelector(`option[value="${id}"]`).selected = true;
                $(selectElement).change();

                // handle displayed list
                const liElement = document.querySelector(
                    `.multiselect-container li a[data-field-value="${id}"]`
                );
                if (liElement) {
                    liElement.parentElement.classList.add("active");
                }
            });
        });
}

rEvent.on("Listing.fetchedData", () => {
    updateLazy();
    attachPaginatorEvents();
    initAnchors();

    if ($(".js-pager-current-count").length) {
        $(".js-pager-current-count").html(
            $(".listing.products").first().find(".products__item").length
        );
    }
});

document.addEventListener("DOMContentLoaded", function () {
    attachPaginatorEvents();
    initAnchors();
});
